/**
 * COMPONENT: Back to Top Button
 * Gère l'affichage et le comportement du bouton "retour en haut"
 */

export default class BackToTop {
  constructor() {
    this.button = document.getElementById('back-to-top');
    this.scrollThreshold = 300; // Afficher après 300px de scroll

    if (!this.button) {
      return;
    }

    this.init();
  }

  init() {
    // Écouter le scroll
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });

    // Écouter le clic sur le bouton
    this.button.addEventListener('click', this.scrollToTop.bind(this));

    // Vérifier l'état au chargement
    this.handleScroll();
  }

  handleScroll() {
    const scrollPosition = window.scrollY || window.pageYOffset;

    if (scrollPosition > this.scrollThreshold) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.button.classList.add('is-visible');
  }

  hide() {
    this.button.classList.remove('is-visible');
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
